(function () {
  function formatReviewTimestamps(root) {
    root.querySelectorAll('time.jdgm-rev__timestamp[datetime]').forEach(function (el) {
      var raw = el.getAttribute('datetime');
      if (!raw) return;
      var date = new Date(raw);
      if (Number.isNaN(date.getTime())) return;
      el.textContent = date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
      el.classList.remove('jdgm-spinner');
    });
  }

  function hydrateReviewMedia(root) {
    root.querySelectorAll('img[data-src]').forEach(function (img) {
      if (!img.getAttribute('src')) {
        img.setAttribute('src', img.getAttribute('data-src'));
      }
    });
    root.querySelectorAll('.jdgm--loading').forEach(function (el) {
      el.classList.remove('jdgm--loading');
    });
  }

  function enhance() {
    var root = document.getElementById('judgeme_product_reviews');
    if (!root) return;
    formatReviewTimestamps(root);
    hydrateReviewMedia(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }

  document.addEventListener('jdgm.widget.done', enhance);
})();
